import React from "react";
import { OptionRow } from "../../option-row/OptionRow";
import type {
  DepositMethodId,
  SelectableMethodDescriptor,
} from "features/wallet/components/deposit/types";

type PaymentMethodOptionProps = {
  method: SelectableMethodDescriptor;
  selected: boolean;
  onSelect: (id: DepositMethodId) => void;
};

export const PaymentMethodOption = ({
  method,
  selected,
  onSelect,
}: PaymentMethodOptionProps) => {
  return (
    <OptionRow
      selected={selected}
      onSelect={() => onSelect(method.id)}
      icon={<method.Icon />}
      label={method.label}
      trailing={method.PickerAction && <method.PickerAction />}
    />
  );
};
